import React from 'react';

export default function InputWithRangeIntegration(props) {
    const {
        handleRangeChange,
        id,
        inputLabel,
        label,
        maxValue,
        minValue,
        name,
        step,
        valueToDisplay,
        validateValue,
        disabled
    } = props;


    return (
        <React.Fragment>
            <label className="visually-hidden-accessible" htmlFor={id}>{inputLabel}</label>
            <input
                type="number"
                className="range__input"
                min={minValue}
                max={maxValue}
                id={id}
                name={name}
                value={`${valueToDisplay}`}
                onChange={handleRangeChange}
                onBlur={validateValue}
                step={step}
                disabled={disabled}
            />
            { label && (<span className="range__unit">{label}</span>) }
        </React.Fragment>
    );
}
